// RedeemRewardPage.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAuthSession } from "@aws-amplify/auth";

const API_BASE_URL = "https://api.cupvisor.org";

function RedeemRewardPage({ user, signOut }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [jwtToken, setJwtToken] = useState("");
  const [redeemResponse, setRedeemResponse] = useState(null);

  // Extract redeemToken from URL.
  const queryParams = new URLSearchParams(location.search);
  const redeemToken = queryParams.get("redeemToken");

  useEffect(() => {
    async function loadSession() {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        setJwtToken(token);
      } catch (err) {
        console.error("Error loading session:", err);
      }
    }
    loadSession();
  }, [user]);

  useEffect(() => {
    async function redeemReward() {
      if (!jwtToken || !redeemToken) return;
      try {
        const url = `${API_BASE_URL}/vendor/redeem?redeemToken=${encodeURIComponent(redeemToken)}`;
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          "Accept": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        if (!res.ok) {
          throw new Error(`API returned status ${res.status}`);
        }
        const data = await res.json();
        setRedeemResponse(data);
        setTimeout(() => {
          navigate("/vendors", { state: { message: "Reward redeemed" } });
        }, 2000);
      } catch (err) {
        console.error("Error redeeming reward:", err);
        setRedeemResponse({ error: err.message });
        setTimeout(() => {
          navigate("/vendors", { state: { message: "Error: " + err.message } });
        }, 2000);
      }
    }
    redeemReward();
  }, [jwtToken, redeemToken, navigate]);

  return (
    <div className="container mt-4">
      <h2>Processing reward redemption...</h2>
      {redeemResponse ? (
        <div className="alert alert-info mt-3">
          <pre>{JSON.stringify(redeemResponse, null, 2)}</pre>
        </div>
      ) : (
        <p>Please wait while we process the reward redemption...</p>
      )}
    </div>
  );
}

export default RedeemRewardPage;
